import Swal from "sweetalert2";
var $  = require( 'jquery' );
var Sortable  = require('sortablejs').Sortable;
require('bootstrap');
require('sweetalert2')
require('jquery-validation')
require( 'datatables.net-bs5' );
require( 'datatables.net-buttons-bs5' );
require( 'datatables.net-fixedheader-bs5' );
require( 'datatables.net-responsive-bs5' );
require( './body-spinner' );
require( './ajax-global-handlers' );
require( './filters' );
require( './other' );
require('./forms')
require('./ckeditor-init')
var Moment = require('moment')
import globalFunctions from "./global-function";
import { initializeDataTables } from './datatables.js';
window.initSelect2 = (opts = {}, elements = null) => {
    if (!elements) {
        elements = $('.select2');
    }
    const options = {
        width: '100%',
        placeholder: { id: '', text: 'Choose an option' },
        allowClear: true
    };

    for (const opt in opts) {
        options[opt] = opts[opt];
    }

    $.each(elements, function (index, el) {
        const o = { ...options };
        const element = $(el);
        if ('' + element.attr('show-search-bar') !== 'true' && !o.tags) {
            o.minimumResultsForSearch = -1;
        }

        if (element.attr('placeholder')) {
            o.placeholder = { id: '', text: element.attr('placeholder') };
        }

        try {
            element.select2(o);
        } catch (e) {
            console.error(e);
        }
    });
}

window.initClockPicker = (opts = {}, elements = null) => {
    if (!elements) {
        elements = $('.clockpicker');
    }
    const options = {};

    for (const opt in opts) {
        options[opt] = opts[opt];
    }
    $.each(elements, function (index, el) {
        const o = { ...options };
        const element = $(el);
        try {
            element.clockpicker(o);
        } catch (e) {
            console.error(e);
        }
    });
}

(async function(){
    $(document).ready(function () {
        globalFunctions();

        initializeDataTables();

        initSelect2();

        initClockPicker();
    });
})();

window.$ = $;
window.Swal = Swal;
window.Sortable = Sortable;
window.Moment = Moment;

import Echo from "laravel-echo";

window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: false,
    forceSSL: false,
});



